import React, { useEffect, useState } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { useProductsContext } from '../../context/products_context';
import { single_product_url as url } from '../../utils/constants';
import { formatPrice } from '../../utils/helpers';
import "./index.css"
import {
  Loading,
  Error,
  ProductImages,
  AddToCart,
  Stars,
  PageHero,
  ReviewModal,
  UserReview,
} from '../../components';
import Wrapper from './styles';
import axios from 'axios';
import { IoMdHeartEmpty } from 'react-icons/io';
import { toast } from 'react-toastify';
import { useUserContext } from '../../context/user_context';
import { AiOutlineGift } from 'react-icons/ai';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import ProductList from '../ProductPage/ProductList';
import { useFilterContext } from '../../context/filter_context';
import divider from '../../assets/divider.svg';
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Input,
} from '@chakra-ui/react';
import { FaWhatsapp } from 'react-icons/fa';
import WhatsappPopup from '../../components/Popups/whatsappPopup';
const SingleProductPage = () => {
  const { id } = useParams();
  const history = useHistory();
  const [options, setOptions] = useState([]);
  const { currentUser } = useUserContext();
  const [mainSize, setMainSize] = useState();
  const {
    single_product_loading: loading,
    single_product_error: error,
    single_product: product,
    fetchSingleProduct,
  } = useProductsContext();
  const [wishlistButtonText, setWishlistButtonText] =
    useState('Add to wishlist');
  const { filtered_products: products } = useFilterContext();
  const [wishlistButton, setWishlistButton] = useState(
    <FaRegHeart className='heart' fill='#D3A143' />
  );
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isOpenWhatsapp, setIsOpenWhatsapp] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    fetchSingleProduct(`${url}/${id}`);
    // eslint-disable-next-line
  }, [id]);
  const fetchData = async () => {
    let isMounted = true;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_HOST}/api/filters`
      );
      if (!isMounted) return;
      let data = response.data.data.filter((e) => e.name === 'Sizes');
      //    let filters=data[0].options.map((e)=>e.name)
      //    setOptions(filters)
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    return () => {
      isMounted = false;
    };
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        history.push('/');
      }, 3000);
    }
    // eslint-disable-next-line
  }, [error]);

  const {
    name,
    price,
    rating: stars,
    numberOfReviews,
    reviews = [],
    mrp,
    discountPercentage,
    showDiscount,
    discount,
    bestOffers,
    sizeChart,
    taxPrice,
    sizes,

    productWeight,
  } = product;

  const careInstructions = [
    {
      title: 'Store Properly',
      description:
        'Keep your jewelry in a dry, cool place. Use a soft cloth or a jewelry box with compartments to prevent scratching and tangling.',
    },
    {
      title: 'Avoid Chemicals',
      description:
        'Keep your jewelry away from harsh chemicals, including cleaning products, perfumes, and lotions. Apply these products before putting on your jewelry.',
    },
    {
      title: 'Limit Exposure',
      description:
        'Remove jewelry before swimming, exercising, or engaging in activities that may cause it to get scratched or damaged.',
    },

    {
      title: 'Clean Gently',
      description:
        'Clean your jewelry regularly using a soft cloth. For more thorough cleaning, use mild soap and warm water. Avoid abrasive materials that can scratch the surface.',
    },
    {
      title: 'Check for Damage',
      description:
        'Regularly inspect your jewelry for any signs of wear or damage, such as loose stones or clasps. Address any issues promptly to avoid further damage.',
    },
    {
      title: 'Avoid Moisture',
      description:
        'Keep jewelry away from moisture and humidity, which can cause tarnishing, especially with sterling silver.',
    },
  ];

  const shippingPolicy = [
    {
      title: 'Processing Time',
      description:
        'All orders are processed within 5-7 business days. You will receive a confirmation email once your order has shipped.',
    },

    {
      title: 'Domestic Shipping',
      description:
        'Free shipping on all orders. Typical delivery time is 5-7 business days.',
    },
  ];

  const returnPolicy = [
    {
      title: 'Condition',
      description:
        'Items must be in their original condition, unworn, and include all packaging. Personalized or custom items are non-returnable. To proceed with an exchange or return, please ensure the opening video is mandatory',
    },
    {
      title: 'Exchange Process',
      description:
        'Exchange is possible only by branch visit within 7 days of purchase.',
    },
  ];
  const [activeTab, setActiveTab] = useState('details');

  const tabItems = [
    { id: 'details', label: 'Details' },
    { id: 'description', label: 'Description' },
    { id: 'care', label: 'Care Instructions' },
    { id: 'shipping', label: 'Shipping and Exchange' },
  ];

  useEffect(() => {
    if (name) {
      document.title = `Mukunda jewelers | ${name}`;
    }
    if (sizes) {
      setMainSize(sizes[0]);
    }
  }, [name, sizes]);

  useEffect(() => {
    let isMounted = true;

    const checkWishlistStatus = async () => {
      try {
        if (currentUser && id) {
          const userid = currentUser.id;

          const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`
          );

          if (!isMounted) return;

          const array = response.data.data;
          const isPresent = array?.some((e) => e.id == id);
          if (array !== null) {
            setWishlistButtonText(
              isPresent ? 'Remove from Wishlist' : 'Add to Wishlist'
            );
            setWishlistButton(
              isPresent ? (
                <FaHeart className='heartSelected' fill='#D3A143' />
              ) : (
                <FaRegHeart className='heart' fill='#D3A143' />
              )
            );
          } else {
            setWishlistButtonText('Add to Wishlist');
          }
        }
      } catch (err) {
        console.error('Error checking wishlist:', err);
      }
    };

    checkWishlistStatus();
  }, [id]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Error />;
  }

  const handleShare = async () => {
    const shareData = {
      title: name || 'Mukunda silver jewelery',
      text: `Check out "${name}" on mukunda`,
      url: window.location.href,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(
          `${shareData.text}: ${shareData.url}`
        );
        alert('Link copied to clipboard!');
      } else {
        prompt('Copy this link:', shareData.url);
      }
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('Share failed:', err);
      }
    }
  };

  const handleWishlistButton = async (id) => {
    let userid = currentUser?.id;
    if (currentUser) {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`
      );
      const array = response?.data?.data || [];

      let isPresent = array.some((e) => e.id == id);
      let options = { wishlistItem: Number(id) };
      if (!isPresent) {
        try {
          let res = await axios.put(
            `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`,
            { id }
          );
          toast.success('Item added to wishlist');
          setWishlistButtonText('Remove from wishlist');
          setWishlistButton(
            <FaHeart className='heartSelected' fill='#D3A143' />
          );
        } catch (error) {
          console.error('Error adding item to wishlist:', error);
        }
      } else {
        try {
          const data = {
            wishlistItem: id,
          };
          const userid = currentUser?.id;
          const response = await axios.delete(
            `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`,
            { data }
          );

          toast.success('Item removed from wishlist');
          setWishlistButtonText('Add to wishlist');
          setWishlistButton(<FaRegHeart className='heart' fill='#D3A143' />);
        } catch (error) {
          console.error('Error deleting item from wishlist:', error);
        }
      }
    } else {
      onOpen();
    }
  };


  return (
    <div className='px-4 md:px-8 lg:px-16 py-6 mx-auto w-full'>
      <Link to='/collections'>
        <p className='underline text-sm mb-4 text-gray-600'>
          ← Continue shopping
        </p>
      </Link>
      <div className='flex flex-col lg:flex-row gap-4 md:gap-10 w-full'>
        <ProductImages product={product} />
        <div className='flex flex-col gap-1 w-full'>
           <div className="safe-marquee text-sm text-pri">
            <span>
                Future polishing charges are ₹25 per gram. For items below 10
                grams, a minimum charge of ₹200 applies. Please visit the
                nearest store for this service
              </span>
            </div>
          <div className='flex flex-col xl:flex-row gap-4 justify-between'>
            <Link to={`/collections?category=${product.category}`}>
              <span className='underline underline-offset-1 text-sm md:text-[16px]'>
                {product.category}
              </span>
            </Link>
            <div className='flex flex-col lg:flex-row gap-2'>
              <div>
                <button
                  className='flex gap-2 items-center bg-[#D3A143] text-white rounded-md p-3 cursor-pointer'
                  onClick={() => {
                    !currentUser ? onOpen() : setIsOpenWhatsapp(true);
                  }}
                >
                  <FaWhatsapp fill='green' className='text-xl' />
                  <p className='text-white'>Video call assistance</p>
                </button>
              </div>
              <div
                className='flex gap-3 items-center cursor-pointer'
                onClick={() => handleWishlistButton(product.id)}
              >
                <p className='text-xl lg:text-2xl'>{wishlistButton}</p>{' '}
                <p className='text-gray-700'>{wishlistButtonText}</p>{' '}
              </div>
            </div>
          </div>
          <div className='flex flex-col gap-4'>
            <p className='font-semibold text-lg text-[#222222]'>
              {product?.name ||
                '999 Silver 3 piece cup with peacock handle Designer set'}{' '}
            </p>
            <Stars stars={stars} reviews={numberOfReviews} />{' '}
            {product?.size && (
              <p className='font-bold text-lg text-[#222]'>
                Size: <span className='font-medium'>{product.size}</span>{' '}
              </p>
            )}
            <div className='hidden md:flex flex-col gap-2 w-full break-words whitespace-normal'>
              <label className='text-sm font-semibold'>Description</label>

              <p className='text-sm font-light break-words whitespace-normal block w-full'>
                {product.description}
              </p>
            </div>
            <AddToCart product={product} />
          </div>
        </div>
      </div>

      <hr className='my-6' />

      <div className='w-full mt-6'>
        <div className='flex flex-wrap gap-4 border-b border-gray-300 pb-2'>
          {tabItems.map((tab) => (
            <button
              key={tab.id}
              className={`text-sm md:text-base font-semibold transition-colors
              ${
                activeTab === tab.id
                  ? 'text-[#D3A143] border-b-2 border-[#D3A143]'
                  : 'text-gray-700'
              }
            `}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className='mt-4 text-gray-700 text-sm md:text-base leading-relaxed'>
          {activeTab === 'details' && (
            <ul className='space-y-1'>
              <li>
                <strong>SKU:</strong> {product?.productCode}
              </li>
              <li>
                <strong>Purity:</strong> 92.5 silver
              </li>
              <li>
                <strong>Branch availability: </strong>
                {product.branch || 'Kothapeta'}
              </li>
              <li>
                <strong>Weighig around:</strong> {product.weight}
              </li>
              <li>
                <strong>MRP price:</strong> {formatPrice(product?.subPrice)}
              </li>

              <li>
                <strong>Tax Charges:</strong> {formatPrice(product?.taxPrice)}
              </li>
            </ul>
          )}

          {activeTab === 'description' && <p>{product?.description}</p>}

          {activeTab === 'care' && (
            <div>
              <p>
                To keep your jewelry looking its best and ensure longevity,
                follow these care tips:
              </p>
              <ol className='list-decimal ml-5 mt-2 space-y-1'>
                {careInstructions.map((item, index) => (
                  <li key={index}>
                    <strong>{item.title}:</strong> {item.description}
                  </li>
                ))}
              </ol>
              <p className='mt-2'>
                By following these steps, you can keep your jewelry beautiful
                for years!
              </p>
            </div>
          )}

          {activeTab === 'shipping' && (
            <div>
              <p className='underline font-semibold mb-1'>Shipping Policy</p>
              <ul className='ml-4 list-disc space-y-1'>
                {shippingPolicy.map((item, index) => (
                  <li key={index}>
                    <strong>{item.title}:</strong> {item.description}
                  </li>
                ))}
              </ul>

              <p className='underline font-semibold mt-3 mb-1'>
                Exchange Policy
              </p>
              <ul className='ml-4 list-disc space-y-1'>
                {returnPolicy.map((item, index) => (
                  <li key={index}>
                    <strong>{item.title}:</strong> {item.description}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>

      <h1 className='text-center text-xl font-bold mt-8'>You May Also Like</h1>
      <div className='flex justify-center items-center py-2 gap-3'>
        <div className='border border-[#F4B41A] w-1/3'></div>
        <img src={divider} />
        <div className='border border-[#F4B41A] w-1/3'></div>
      </div>

      <div className='w-full grid grid-flow-row xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 grid-cols-2 mb-3 gap-4'>
        {products.slice(1, 5).map((item) => (
          <ProductList key={item.id} data={item} id={item.id} />
        ))}
      </div>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent className='m-5'>
          <ModalHeader>Please Login</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Please login to add items to your cart, wishlist and for video
            calling assistance.
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose}>
              Close
            </Button>
            <Link to='/login'>
              <Button variant='ghost'>Login</Button>
            </Link>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {isOpenWhatsapp && (
        <WhatsappPopup
          setIsOpenWhatsapp={setIsOpenWhatsapp}
          productId={product.productCode}
          username={currentUser.username}
        />
      )}
    </div>
  );
};

export default SingleProductPage;
